import React, {Component, useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Drawer from "@material-ui/core/Drawer";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import StructureVisibilityButton from "./StructureVisibilityButton";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import SelectFramesButton from "./SelectFramesButton";
import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";
import NGLContext from '../../NGLContext'
import {viewHeight} from '../ViewPanel'
import ListSubheader from "@material-ui/core/ListSubheader";
import ComponentHeader from './ComponentHeader';
import {makeStyles} from "@material-ui/styles";
import {Radio} from "@material-ui/core";
import {ExpandLess, ExpandMore} from "@material-ui/icons";
import IconButton from "@material-ui/core/IconButton";
import MoreHorizOutlinedIcon from '@material-ui/icons/MoreHorizOutlined';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import {RepresentationRegistry} from "ngl";
import FormHelperText from '@material-ui/core/FormHelperText';


export const drawerWidth = 300;
const styles = theme => ({
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        left: 'auto',
        top: 'auto',
        position: 'absolute',
        height: viewHeight,
        width: drawerWidth,
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    button: {
        // margin: theme.spacing.unit,
        outline: 'none !important',
    },
});

const useStyles = makeStyles(theme => ({
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        left: 'auto',
        top: 'auto',
        position: 'absolute',
        height: viewHeight,
        width: drawerWidth,
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    button: {
        // margin: theme.spacing.unit,
        outline: 'none !important',
    },
    formControl: {
        // margin: theme.spacing(1),
        width: "100%"
        // minWidth: 150,
        // maxWidth: 300,
    },
}));


function AddRepresentationListItem({itemKey, component, refresh}) {
    const classes = useStyles();
    const [reprType, setReprType] = useState("");
    const molComp = component ? component : null;
    const compKey = itemKey ? itemKey : "";
    const addRepresentation = () => {
        if (molComp) {
            molComp.addRepresentation(reprType)
        }
        if (refresh) {
            refresh()
        }
    };
    return <ListItem
        className={classes.nested}
        key={compKey}
    >
        <ListItemIcon>
            <IconButton
                aria-label="add-representation-button"
                color="primary"
                onClick={addRepresentation}
                className={classes.button}
            >
                <AddCircleOutlineIcon/>
            </IconButton>
        </ListItemIcon>
        <ListItemText
            primary={
                <FormControl className={classes.formControl}>
                    <InputLabel
                        htmlFor="repr-add-helper">Representation</InputLabel>
                    <Select
                        value={reprType}
                        onChange={(event) => {
                            setReprType(event.target.value)
                        }}
                        inputProps={{
                            name: 'representation',
                            id: 'repr-add-helper',
                        }}
                    >
                        {RepresentationRegistry.names.map((reprName, reprIdx) => (
                            <MenuItem
                                key={`${reprName}-${reprIdx.toString()}`}
                                value={reprName}
                            >
                                {reprName}
                            </MenuItem>
                        ))
                        }
                    </Select>
                    <FormHelperText>Add a new representation</FormHelperText>
                </FormControl>
            }>
        </ListItemText>
    </ListItem>
}

function ComponentItem(props) {
    const classes = useStyles();
    const context = useContext(NGLContext);
    const componentIndex = props.index;
    const component = props.item;
    const [refresh, setRefresh] = useState(false);
    const handleRadio = () => {
        context.handleCompListItemClick(componentIndex);
    };
    const handleSubRadio = (compIndex, reprIndex) => {
        context.handleReprListItemClick(compIndex, reprIndex)
    };
    const handleCollapse = () => {
        context.handleComponentFold(componentIndex);
    };
    const openSubList = context.componentFolds[componentIndex];
    return <React.Fragment>
        {component.reprList &&
        <ListItem
            key={`struct-comp-list-item-${componentIndex}`}
            dense
        >
            <ListItemIcon>
                <Radio
                    checked={context.componentIndex === componentIndex}
                    value={componentIndex}
                    onChange={handleRadio}
                    color="primary"
                    name="struct-comp-radio-button"
                />
            </ListItemIcon>
            <ListItemText
                primary={component.name ? component.name.replace(/\..+/g, '') : 'null'}
                secondary={`${component.structure.modelStore.count} models`} />
            <ListItemSecondaryAction>
                <IconButton
                    edge="end"
                    aria-label="expand-subcomplist-button"
                    onClick={handleCollapse}
                    className={classes.button}
                >
                    {openSubList ? <ExpandLess/> : <ExpandMore/>}
                </IconButton>
            </ListItemSecondaryAction>
        </ListItem>
        }

        <Collapse in={openSubList} timeout="auto">
            <List component="div" disablePadding>
                {component.reprList && component.reprList.map((reprItem, index) =>
                    <ListItem
                        className={classes.nested}
                        key={`struct-comp-sublist-item-${reprItem.name}-${index}`}>
                        <ListItemIcon>
                            <Radio
                                checked={context.representationIndex[componentIndex] === index}
                                value={index}
                                onChange={() => handleSubRadio(componentIndex, index)}
                                color="primary"
                                name="struct-comp-radio-button"
                            />
                        </ListItemIcon>
                        <ListItemText
                            primary={reprItem.name}>
                        </ListItemText>
                        <ListItemSecondaryAction>
                            <IconButton
                                edge="end"
                                aria-label="expand-subcomplist-button"
                                onClick={context.handleBottomPanel}
                                className={classes.button}
                            >
                                <MoreHorizOutlinedIcon/>
                            </IconButton>
                        </ListItemSecondaryAction>
                    </ListItem>
                )}
                {component.reprList &&
                <AddRepresentationListItem
                    itemKey={`struct-comp-sublist-add-item-${component.name}`}
                    component={component}
                    refresh={() => {setRefresh(prevState => !prevState)}}
                />
                }
            </List>
        </Collapse>
    </React.Fragment>
};

function ComponentList(props) {
    return <React.Fragment>
        <List
            subheader={
                <ListSubheader><ComponentHeader/></ListSubheader>}
        >
            {props.dataitems && props.dataitems.map((dataItem, index) =>
                <ComponentItem
                    index={index}
                    key={index}
                    item={dataItem}
                />
            )}
        </List>

    </React.Fragment>
};


@withStyles(styles)
class SidePanel extends Component {

    static propTypes = {
        classes: PropTypes.object.isRequired,
    };

    state = {};

    render() {
        const {classes} = this.props;

        return (
            <NGLContext.Consumer>
                {(contextNGL) => (
                    <React.Fragment>
                        <Drawer
                            className={classes.drawer}
                            variant="persistent"
                            classes={{
                                paper: classes.drawerPaper,
                            }}
                            anchor="left"
                            open={contextNGL.drawerOpened}
                        >
                            <ComponentList
                                dataitems={contextNGL.stage ? contextNGL.stage.compList : []}
                            />

                        </Drawer>
                    </React.Fragment>
                )}
            </NGLContext.Consumer>
        );
    }
}

export default SidePanel;